import { Text, Pressable, View } from "react-native";

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionTitleText,
} from "ui/gluestack/accordion";

import {
  Checkbox,
  CheckboxIndicator,
  CheckboxIcon,
  CheckboxLabel,
} from "ui/gluestack/checkbox";

import { ChevronDownIcon, ChevronUpIcon, CheckIcon } from "ui/gluestack/icon";

import { FloorsIndexResponse } from "app/services/api/types/locations/responses/FloorsIndexResponse";

type FilterMenuProps = {
  floors: FloorsIndexResponse;
  selectedFloorIds: number[];
  toggleFloor: (floorId: number) => void;
  selectedRoomIds: number[];
  toggleRoom: (roomId: number) => void;
  unassignedSelected: boolean;
  toggleUnassigned: () => void;
};

export const FilterMenu = ({
  floors,
  selectedFloorIds,
  toggleFloor,
  selectedRoomIds,
  toggleRoom,
  unassignedSelected,
  toggleUnassigned,
}: FilterMenuProps) => {
  return (
    <Accordion type="multiple" isCollapsible className="min-w-80 md:min-w-96">
      {floors.map((floor) => (
        <AccordionItem
          key={floor.id}
          value={floor.id.toString()}
          className="bg-white"
        >
          <AccordionHeader>
            <View className="flex-row justify-between items-center px-3 py-2 w-full ">
              <Pressable
                onPress={(e) => {
                  e.stopPropagation();
                  toggleFloor(floor.id);
                }}
                className="flex-row items-center "
              >
                <Checkbox
                  value={floor.id.toString()}
                  size="sm"
                  isChecked={selectedFloorIds.includes(floor.id)}
                >
                  <CheckboxIndicator className="rounded-sm">
                    <CheckboxIcon as={CheckIcon} />
                  </CheckboxIndicator>
                </Checkbox>
              </Pressable>

              <AccordionTrigger className="flex-1 flex-row items-center justify-between px-3">
                {({ isExpanded }) => {
                  return (
                    <>
                      <AccordionTitleText className="text-base font-normal ml-3">
                        Floor {floor.floor_number}
                      </AccordionTitleText>
                      {isExpanded ? (
                        <AccordionIcon as={ChevronUpIcon} />
                      ) : (
                        <AccordionIcon as={ChevronDownIcon} />
                      )}
                    </>
                  );
                }}
              </AccordionTrigger>
            </View>
          </AccordionHeader>

          <AccordionContent className="sm:pl-6 pb-5 text-typography-500 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
            {floor.rooms.length > 0 ? (
              floor.rooms.map((room) => (
                <Pressable
                  key={room.id}
                  onPress={(e) => {
                    e.stopPropagation();
                    toggleRoom(room.id);
                  }}
                  className="flex-row items-center"
                >
                  <Checkbox
                    value={room.id.toString()}
                    size="sm"
                    isChecked={selectedRoomIds.includes(room.id)}
                  >
                    <CheckboxIndicator className="rounded-sm">
                      <CheckboxIcon as={CheckIcon} />
                    </CheckboxIndicator>
                    <CheckboxLabel className="text-base font-normal ml-3">
                      Room {room.room_number}
                    </CheckboxLabel>
                  </Checkbox>
                </Pressable>
              ))
            ) : (
              <Text>No rooms available.</Text>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
      <AccordionItem value="unassigned">
        <AccordionHeader>
          <View className="flex-row justify-between items-center px-3 py-2 w-full ">
            <Pressable
              onPress={toggleUnassigned}
              className="flex-row items-center"
            >
              <Checkbox
                value="unassigned"
                size="sm"
                isChecked={unassignedSelected}
              >
                <CheckboxIndicator className="rounded-sm">
                  <CheckboxIcon as={CheckIcon} />
                </CheckboxIndicator>
                <CheckboxLabel className="text-base font-normal ml-3">
                  Unassigned
                </CheckboxLabel>
              </Checkbox>
            </Pressable>
          </View>
        </AccordionHeader>
      </AccordionItem>
    </Accordion>
  );
};
